import React from "react";
import Mathematics from "../../components/ClassFour/Mathematics";

import MathematicsMenu from "./Mathematics";

// Define the type for menu items
interface MenuItem {
    url: string;
    title: string;
    component?: React.FC; // Optional React functional component
    subMenu?: MenuItem[]; // Allow subMenu to be an array of MenuItem
}

// Define ClassTwoMenu with the proper type
const ClassFourMenu: MenuItem[] = [
    { 
        url: "/class-four/mathematics", 
        title: "Mathematics", 
        component: Mathematics,
        subMenu: MathematicsMenu
    },
    // { 
    //     url: "/class-three/english", 
    //     title: "English Language", 
    // },
    // { 
    //     url: "/class-three/general-science", 
    //     title: "General Science", 
    // },
    // { 
    //     url: "/class-three/general-knowledge", 
    //     title: "General Knowledge", 
    // },
    // { 
    //     url: "/class-three/social-studies", 
    //     title: "Social Studies", 
    // },
    // { 
    //     url: "/class-three/computer", 
    //     title: "Computer", 
    // }
];

export default ClassFourMenu;